export type Tone = 'red' | 'orange' | 'green' | 'blue' | 'gray';
export function Badge({ tone = 'gray', children }: { tone?: Tone; children: string }) {
  return <span className={`badge ${tone}`}>{children}</span>;
}
